import { useCallback, useEffect, useState } from 'react'
import { Button, DatePicker, Form } from 'antd'
import dayjs from 'dayjs';
import { SearchOutlined } from '@ant-design/icons'
import { GetHistoricalBunker } from '../../../Api/getData';
import { useSearchParams } from 'react-router-dom';

const { RangePicker } = DatePicker;

const StartRange = () => {
    // Ambil tanggal hari ini
    const startOfDay = dayjs().startOf('day'); // Mulai hari ini jam 00:00:00
    const formattedDateTime = startOfDay.format('YYYY-MM-DD HH:mm:ss');
    return formattedDateTime;
};

// EndRange: Waktu saat ini
const EndRange = () => {
    const currentDate = dayjs();
    const formattedDateTime = currentDate.format('YYYY-MM-DD HH:mm:ss');
    return formattedDateTime;
};

const FilterBucker = ({ onData }) => {
    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = useCallback(async (startDate, endDate) => {
        setIsLoading(true);
        try {
            const [response] = await GetHistoricalBunker({
                AccountId: KodeCabang,
                ObjectCode: ShipCode,
                StartDate: startDate,
                EndDate: endDate,
            });
            onData(response);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }, [KodeCabang, ShipCode]);

    useEffect(() => {
        fetchData(StartRange(), EndRange());
    }, [fetchData]);

    const onSubmit = async (values) => {
        const { RangeDate } = values;

        const startDateRange = RangeDate ? dayjs(RangeDate[0]).format('YYYY-MM-DD HH:mm:ss') : StartRange();
        const endDateRange = RangeDate ? dayjs(RangeDate[1]).format('YYYY-MM-DD HH:mm:ss') : EndRange();

        try {
            fetchData(startDateRange, endDateRange);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div>
            <Form
                // layout="inline"
                onFinish={onSubmit}
                form={form}
                initialValues={{
                    'RangeDate': [dayjs(StartRange()), dayjs(EndRange())]
                }}
            >
                <div className="w-full flex border rounded-xl p-4 gap-4">
                    <Form.Item
                        name="RangeDate"
                        noStyle
                    >
                        <RangePicker
                            showTime={{
                                format: 'HH:mm:ss',
                            }}
                            format="YYYY-MM-DD HH:mm:ss"
                        />
                    </Form.Item>
                    <Button
                        htmlType="submit"
                        icon={<SearchOutlined />}
                        loading={isLoading}
                        style={{ width: '40px' }}
                    />
                </div>
            </Form >
        </div>
    )
}

export default FilterBucker
